import {
	IGetRoles,
	IGetLanguages,
	IGetCountries,
	IGetCities,
	IGetActualFilePath,
	IGetActualFileObject,
	IPostMediaFile,
	IGetCurrencies,
	TPhotoSize,
	IGetMediaFilePathResponse,
	IGetBankSettingsAcquirers,
	IGetAcquirers,
	IGetMediaFilePathArgs,
	IGetFeatureFlags,
} from 'types';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { request } from '../index';

const serviceGetRoles = (): Promise<IGetRoles> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Roles` });
};

const serviceGetLanguages = (): Promise<IGetLanguages> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Languages` });
};

const serviceGetCountries = (): Promise<IGetCountries> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Countries` });
};

const serviceGetCities = (countryID: string): Promise<IGetCities> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Cities?countryId=${countryID}` });
};

const serviceGetActualFilePath = (filePath: string): Promise<IGetActualFilePath> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/File/presigned-url?filePath=${filePath}` });
};

const serviceGetActualFileObject = (filePath: string): Promise<IGetActualFileObject> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/File/file-object?filePath=${filePath}` });
};

const serviceDownloadBlob = (filePath: string): Promise<AxiosResponse<Blob>> => {
	return request({ typeOfRequest: 'downloadBlob', url: `/api/File/file-object?filePath=${filePath}` });
};

const servicePostMediaFile = ({
	data,
	config,
}: {
	data: FormData;
	config?: AxiosRequestConfig;
}): Promise<IPostMediaFile> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/File/interim`, data, config });
};

const servicePostMediaFileForStyleSettings = (data: FormData): Promise<IPostMediaFile> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/File/media-translations/upload`, data });
};

const serviceGetCurrencies = (): Promise<IGetCurrencies> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Currencies` });
};

const serviceGetFilePathForMediaFilesWithSizeForStyleSettings = (
	translationID: string,
	photoSize: TPhotoSize,
): Promise<IGetMediaFilePathResponse> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/File/media-translations/${translationID}/file?size=${photoSize}`,
	});
};

const serviceGetBankSettingsAcquirers = (args: IGetBankSettingsAcquirers): Promise<IGetAcquirers> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Acquirers/batch`, data: args });
};

const serviceGetBankSettingsAcquirersByRestaurantId = (restaurantID: string): Promise<IGetAcquirers> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/Acquirers/AvailableForBankSettings?restaurantId=${restaurantID}`,
	});
};

const serviceGetMediaFilePath = (args: IGetMediaFilePathArgs): Promise<IGetMediaFilePathResponse> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/${args.resource}/${args.entityID}/photo?size=${args.size}`,
	});
};

const serviceGetMediaFilePathMenuV2 = (args: IGetMediaFilePathArgs): Promise<IGetMediaFilePathResponse> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/${args.resource}/${args.entityID}?size=${args.size}`,
	});
};

const serviceGetFeatureFlags = (): Promise<IGetFeatureFlags> => {
	return request({ typeOfRequest: 'getWithToken', url: '/api/v1/FeatureFlags' });
};

export {
	serviceGetRoles,
	serviceGetLanguages,
	serviceGetCountries,
	serviceGetCities,
	serviceGetActualFilePath,
	serviceGetActualFileObject,
	serviceDownloadBlob,
	servicePostMediaFile,
	servicePostMediaFileForStyleSettings,
	serviceGetCurrencies,
	serviceGetFilePathForMediaFilesWithSizeForStyleSettings,
	serviceGetBankSettingsAcquirers,
	serviceGetBankSettingsAcquirersByRestaurantId,
	serviceGetMediaFilePath,
	serviceGetMediaFilePathMenuV2,
	serviceGetFeatureFlags,
};
